// project section
const projectsData = [{
    id:"1",
    name:"Technology & Equipment Distribution",
    category:"Supplying mission-critical hardware from global leaders.",
    description: "As an authorized distributor for 20+ top-tier technology brands, MXI supplies and integrates hardwares. We provide not just the hardware, but full-stack integration and lifecycle support.",
    img: {
        default:'/Assets/images/projects/Editor.webp', 
        classpath: ''
    }
    // , equipped with both admin and editorial portals for managing user access and permissions, quoting articles from feeds, publishing to output channels for ingestion by other media streams, and much more
},{
    id:"2",
    name:"AI-Powered Workflow & Tactical Systems",
    category:"Intelligent operations. Context-aware decisions.",
    description: "Our proprietary platforms embed AI and automation into the core of operational workflows—empowering organizations to act smarter, faster, and more securely.",
    img: {
        default:'/Assets/images/projects/OCR.webp', 
        classpath: 'brightness-75'
    }
    // This helps eliminate manual entry, consequently reducing errors and increasing productivity.
},{
    id:"3",
    name:"Form Management & Data Ingestion Platforms",
    category:"Geo-aware, secure, and structured for impact.",
    description: "MXI's custom data systems support complex multi-source data ingestion, validation, and visualization.",
    img: {
        default:'/Assets/images/projects/FIS.webp', 
        classpath: ''
    }
    // , we successfully resolved all issues related to it.
},{
    id:"4",
    name:"Real-Time Dashboards & Compliance Analytics",
    category:"Situational awareness, performance tracking, and executive decision support.",
    description: "We develop real-time dashboards and analytics interfaces customized for Newsrooms & editorial control, Defense command rooms, Financial operations centers and National agencies with compliance obligations",
    img: {
        default:'/Assets/images/projects/ERMS.webp', 
        classpath: 'object-top brightness-90'
    }
},{
    id:"5",
    name:"Video & Audio Engineering Systems",
    category:"Precision broadcast infrastrucure. Designed to perform. Build to last.",
    description: "MXI has deep expertise in video and audio ingesting and distribution platforms, engineered for high-performance environments such as live broadcasting, tactical field ops, and studio production.",
    img: {
        default:'/Assets/images/projects/ECOMM.webp', 
        classpath: ''
    }
    
},{
    id:"6",
    name:"Digital Transformation Services",
    category:"Future-proofing your systems, without disrupting your mission.",
    description: "MXI helps organizations modernize legacy platforms with secure, scalable, AI-enabled replacements—preserving mission-critical data while enhancing operational capabilities.",
    img: {
        default:'/Assets/images/projects/HDTech.webp', 
        classpath: 'object-top brightness-90'
    }
}
// ,{
//     id:"7",
//     name:"Infrastructure Setup",
//     category:"IT Infrastructure",
//     description: "We successfully set up a NAS system with firewall security for office use, supplied servers capable of daily tasks and hosting their website, reducing cloud subscription costs",
//     img: {
//         default:'/Assets/images/projects/infra.webp', 
//         classpath: 'brightness-90'
//     }
// }
];

export default projectsData;